<template>
    <div class="header">
        <div class="container">
            <div class="left">
                <slot name="left"></slot>
            </div>
            <div class="center">
                <slot name="center"></slot>
            </div>
            <div class="right">
                <slot name="right"></slot>
            </div>
<!--            <div class="additional">-->
<!--                <slot name="additional"></slot>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "HeaderContainer"
    };
</script>

<style scoped lang="scss">
    .header {
        background-color: #EEF2F6;
        height: 56px;
        width: 100%;
        .container {
            display: flex;
            align-items: center;
            height: 100%;
            > div {
                display: flex;
                align-items: center;
                height: 100%;
            }
            .left {
                width: 20%;
            }
            .center {
                flex: 1;
            }
            .right {
                width: 30%;
            }
        }
    }
</style>
